import { ContainerComponent, wrap } from 'AppReact';
import getIsMobile from 'components/atoms/utils/getIsMobile';
import { SkillRowDeleteSvg, SkillRowExpandSvg } from 'components/icons';
import { IconButton, Title } from './atoms';
import Controller from './controller';
import internalState from './internalState';
import { Assignments, ChildCategory, Progress } from './molecules';
import { ButtonsWrapper, ExpansionWrapper, HeaderWrapper, Wrapper } from './wrappers';

const isMobile = getIsMobile();

export const definition = {
  name: "SkillRow",
  controller: Controller,
  initialProps: ({ skill }) => ({ skill }),
  props: internalState,
  elements: [
    {
      wrapper: HeaderWrapper,
      isButton: isMobile,
      bindings: ({ open }) => ({ open }),
      name: 'SkillHeader',
      elements: [
        {
          component: Title,
          name: 'Title',
          displayValue: ({ skill }) => skill.name
        },
        {
          component: Progress,
          name: 'ProgressBar',
          bindings: ({ skill }) => ({ skill })
        },
        {
          component: Assignments,
          name: 'AssignmentsCount',
          bindings: ({ skill }) => ({ skill })
        },
        {
          wrapper: ButtonsWrapper,
          name: 'Buttons',
          renderIf: ({ }) => !isMobile,
          elements: [
            {
              component: IconButton,
              name: 'ExpandButton',
              displayValue: ({ open }) => SkillRowExpandSvg({ expanded: open }),
              bindings: ({ open }) => ({ open })
            },
            {
              component: IconButton,
              name: 'DeleteParentButton',
              displayValue: ({ }) => SkillRowDeleteSvg({}),
              bindings: ({ skill }) => ({ skill })
            }
          ]
        }
      ]
    },
    {
      wrapper: ExpansionWrapper,
      name: 'RowBody',
      renderIf: ({ open }) => open,
      elements: [
        {
          component: ChildCategory,
          name: 'ChildCategory',
          isListOf: 'skill.children',
          bindings: ({ child }) => ({ child })
        }
      ]
    }
  ]
}

const SkillRow = ContainerComponent(definition);

export default wrap(SkillRow, Wrapper);
